import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { PartialUiConfiguration } from '~/app/market-config/models/car-confi-ui-configuration';

const q4: PartialCarConfiguration = {
	combinations: ['trimLine', 'packages', 'paint', 'rims', 'headlights', 'interiorPackages', 'steeringWheels'],
};

const q4etron: PartialCarConfiguration = {
	...q4,
	deliveryCostUrl: 'https://www.audi.de/de/brand/de/tools/nemo/commons/delivery-costs/q4etron.html',
};

const q4etron_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

const q4sbetron: PartialCarConfiguration = {
	...q4,
	deliveryCostUrl: 'https://www.audi.de/de/brand/de/tools/nemo/commons/delivery-costs/q4sbetron.html',
};

const q4sbetron_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

export { q4etron, q4etron_ui, q4sbetron, q4sbetron_ui };
